<template>
  <div>
    <div class="smartphones-button-container">
      <v-btn-toggle
        v-if="windowWidth <= 500"
        v-model="mobileTab"
        tile
        color="primary"
        group
      >
        <v-btn value="treeview">
          Tree view
        </v-btn>

        <v-btn value="folder">
          Folder view
        </v-btn>
      </v-btn-toggle>
      <v-btn v-if="windowWidth <= 500"
             icon
      >
        <v-icon @click="$emit('close')">mdi-close</v-icon>
      </v-btn>
    </div>
    <v-btn
      v-if="windowWidth > 500"
      icon
      color="primary"
      @click="$emit('toggle-treeview')"
      class="toogle-treeview-button"
      absolute
    >
      <v-icon>{{ isTreeview ? 'mdi-unfold-less-vertical' : 'mdi-unfold-more-vertical' }}</v-icon>
    </v-btn>
  </div>
</template>

<script>
export default {
  name: "ToggleAndMobileButtons",
  data: function () {
    return {
      isTreeview: true
    }
  },
  computed: {
    mobileTab: {
      get: function () {
        return this.isTreeview ? 'treeview' : 'folder'
      },
      set: function (newValue) {
        this.handleMobileTabs(newValue);
        this.$emit('file-explorer-grid-columns', '1fr')
      }
    },
    windowWidth: function () {
      return window.innerWidth;
    }
  },
  mounted() {
    this.initWindowResizeHandler();
  },
  methods: {
    handleMobileTabs: function (newValue) {
      if (newValue === 'treeview') {
        this.isTreeview = true;
        document.getElementsByClassName('treeview-container')[0].style.display = 'block';
        document.getElementsByClassName('folder')[0].style.display = 'none';
      } else if (newValue === 'folder') {
        document.getElementsByClassName('folder')[0].style.display = 'block';
        document.getElementsByClassName('treeview-container')[0].style.display = 'none';
        this.isTreeview = false;
      }
    },
    initWindowResizeHandler: function () {
      window.addEventListener('resize', () => {
        if (this.windowWidth <= 500) {
          this.handleMobileTabs('treeview');
        } else {
          document.getElementsByClassName('treeview-container')[0].style.display = 'block';
          document.getElementsByClassName('folder')[0].style.display = 'block';
          if (this.isTreeview) {
            this.$emit('file-explorer-grid-columns', '300px 1fr')
          } else {
            this.$emit('file-explorer-grid-columns', '24px 1fr')
          }
        }
      });
    },
  }
}
</script>

<style scoped>
.smartphones-button-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.toogle-treeview-button {
  left: 5px;
  top: 57px;
}
</style>
